export const BUY_ME_A_COFFEE_URL = 'https://buymeacoffee.com/surthrivaling';
